import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { MenuTriggerDirectiveModule } from '@adaptiva/core/menus';
import { DefaultConfigFactoryPipe, GetServerObjectNamePipe } from '@adaptiva/data-service';
import { ClickableComponentModule } from '@adaptiva/widgets/clickable';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { IsLogicTypePipe, LogicalIconPipe } from '@adaptiva/widgets/filter';
import { IconComponent } from '@adaptiva/widgets/icon';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { PrerequisiteObjectIdPipe } from './preqrequisite-object-id.pipe';
import { PrerequisiteTreeComponent } from './prerequisite-tree.component';

const WIDGETS: Type<any>[] = [
	ClickableComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	IconComponent,
	LabelComponentModule,
	MenuComponentModule,
	ObjectListModule,
	OverlayComponentModule,
	TextComponentModule,
];

const PIPES: Type<any>[] = [
	AdaBindMethodPipe,
	DefaultConfigFactoryPipe,
	GetServerObjectNamePipe,
	IsLogicTypePipe,
	LogicalIconPipe,
	PrerequisiteObjectIdPipe,
];

const DIRECTIVES: Type<any>[] = [
	MenuTriggerDirectiveModule,
	TemplateMarkerDirectiveModule,
];

@NgModule({
	imports: [
		CommonModule,
		DIRECTIVES,
		PIPES,
		WIDGETS,
	],
	exports: [PrerequisiteTreeComponent],
	declarations: [PrerequisiteTreeComponent]
})
export class PrerequisiteTreeModule {

}
